import { init_sticky_height } from '../_partials/_sticky-height.js';

init_sticky_height(document.getElementById(`js-hub-letters`));
